import React, { useEffect } from "react";
import "./Wired.css";

// Import images
import FeaturedImage from "../Assets/wire3.png";
import MagazineImage from "../Assets/wire2.jpeg";
import ResponsiveImage from "../Assets/wire1.jpeg";
import PowerfulImage from "../Assets/wire4 (2).jpeg";
import CustomColorsImage from "../Assets/wire5.jpeg";

function Wire() {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <div className="wire-container">
      {/* Featured Post Slideshow */}
      <div className="featured-posts animate-on-scroll">
        <img src={FeaturedImage} alt="Featured Post" className="featured-image" />
        <div className="featured-overlay">
          <h1>EFFICIENT WIRED SOLUTIONS</h1>
          <p>
            Wired technology offers fast, reliable, and secure connections, ensuring stable performance for critical communication and data transmission.
          </p>
        </div>
      </div>

      {/* Post Section */}
      <div className="category-section">
        {/* First Card */}
        <div className="post-card post-left animate-on-scroll">
          <img src={MagazineImage} alt="Magazine Front Page" />
          <div className="card-theory">
            <h3>Local Area Network</h3>
            <p>LAN is a wired networking technology used to connect computers and devices within a limited area, such as a home, office, or campus. It enables high-speed communication and resource sharing like printers and data storage within the network. It is a foundational technology utilized in our company's wired solutions.</p>
          </div>
        </div>

        {/* Second Card */} 
        <div className="post-card post-right animate-on-scroll">
          <div className="card-theory">
            <h3>RECOMMENDED STANDARD 485</h3>
            <p>RS485 is a wired communication standard used for long-distance and reliable data transmission in industrial and automation applications. It supports multiple devices on the same network and is widely used in monitoring and control systems. It is a core technology implemented in our company's wired communication solutions.</p>
          </div>
          <img src={ResponsiveImage} alt="Responsive Layout" />
        </div>

        {/* Third Card */}
        <div className="post-card post-left animate-on-scroll">
          <img src={PowerfulImage} alt="RS232" />
          <div className="card-theory">
            <h3>RECOMMENDED STANDARD 232</h3>
            <p>RS232 is a wired communication standard designed for serial data exchange between devices over short distances. Commonly used for connecting computers to peripherals like modems and printers, it provides a simple and robust solution for point-to-point communication. It is an integral part of our company's wired connectivity offerings.</p>
          </div>
        </div>

        {/* Fourth Card */}
        <div className="post-card post-right animate-on-scroll">
          <div className="card-theory">
            <h3>CAN</h3>
            <p>CAN (Controller Area Network) is a wired communication protocol developed for robust data exchange in real-time applications, such as automotive and industrial systems. It allows multiple devices to communicate efficiently on a single network, reducing wiring complexity. It is a key technology in our company's advanced wired solutions.</p>
          </div>
          <img src={CustomColorsImage} alt="CAN" />
        </div>
      </div>
    </div>
  );
}

export default Wire;